﻿import { Component, OnInit } from '@angular/core';
import { Config } from '../../config/config';

declare var config: Config;

@Component({
    selector: 'echr-footer',
    templateUrl: './echr-footer.component.html',
})
export class EchrFooterComponent implements OnInit {

    public api: string;
    public version: string;
    constructor() {
        this.api = config.apiUrl;
        this.version = config.version;
    }

    ngOnInit() {
    }

}
